module.exports = __webpack_public_path__ + "img/company10.06291b26.png";